<template>
  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.organization_id"
             type="number"
             class="form-control"
             :placeholder="$t('payment_methods.organization_id')">
      <label>{{ $t('payment_methods.organization_id') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.name"
             type="text"
             class="form-control"
             :placeholder="$t('payment_methods.name')">
      <label>{{ $t('payment_methods.name') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.key"
             type="text"
             class="form-control"
             :placeholder="$t('payment_methods.key')">
      <label>{{ $t('payment_methods.key') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.group"
             type="text"
             class="form-control"
             :placeholder="$t('payment_methods.group')">
      <label>{{ $t('payment_methods.group') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.position"
             type="number"
             class="form-control"
             :placeholder="$t('payment_methods.position')">
      <label>{{ $t('payment_methods.position') }}</label>
    </div>
  </div>

  <div class="col-12 mb-3">
    <div class="form-floating">
      <textarea v-model="localFormData.notes"
                class="form-control notes-textarea"
                :placeholder="$t('payment_methods.notes')"></textarea>
      <label>{{ $t('payment_methods.notes') }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethodFormFields',
  props: {
    formData: {
      type: Object,
      required: true,
    }
  },
  emits: ['update:formData'],
  data() {
    return {
      localFormData: {...this.formData},
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.localFormData)) {
          this.localFormData = {...newValue}
        }
      }
    },
    localFormData: {
      deep: true,
      handler(newValue) {
        this.$emit('update:formData', {...newValue})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notes-textarea {
  min-height: 140px;
}
</style>
